import React from 'react';
import './Terms.css';

const Terms = () => {
  return (
    <div className="terms-page">
      <div className="page-header">
        <div className="container">
          <h1>Terms of Service</h1>
        </div>
      </div>

      <div className="terms-content">
        <div className="container">
          <div className="legal-content">
            <p className="last-updated">Last Updated: {new Date().toLocaleDateString()}</p>

            <section>
              <h2>1. Acceptance of Terms</h2>
              <p>
                By accessing and using the Doctors Lab website and services, you accept and agree 
                to be bound by the terms and provision of this agreement. If you do not agree to 
                abide by the above, please do not use this service.
              </p>
            </section>

            <section>
              <h2>2. Use License</h2>
              <p>
                Permission is granted to temporarily access the materials on Doctors Lab's website 
                for personal, non-commercial transitory viewing only. This is the grant of a license, 
                not a transfer of title, and under this license you may not:
              </p>
              <ul>
                <li>Modify or copy the materials</li>
                <li>Use the materials for any commercial purpose or for any public display</li>
                <li>Attempt to reverse engineer any software contained on the website</li>
                <li>Remove any copyright or other proprietary notations from the materials</li>
              </ul>
            </section>

            <section>
              <h2>3. Medical Disclaimer</h2>
              <p>
                The information provided on this website is for informational purposes only and is 
                not intended as medical advice, diagnosis, or treatment. Always seek the advice of 
                your physician or other qualified health provider with any questions you may have 
                regarding a medical condition.
              </p>
            </section>

            <section>
              <h2>4. Privacy and Confidentiality</h2>
              <p>
                Doctors Lab is committed to protecting your privacy and maintaining the confidentiality 
                of your health information in accordance with applicable laws and regulations, including 
                HIPAA. Please review our Privacy Policy for more information.
              </p>
            </section>

            <section>
              <h2>5. Limitation of Liability</h2>
              <p>
                In no event shall Doctors Lab or its suppliers be liable for any damages (including, 
                without limitation, damages for loss of data or profit, or due to business interruption) 
                arising out of the use or inability to use the materials on Doctors Lab's website, even 
                if Doctors Lab or a Doctors Lab authorized representative has been notified orally or 
                in writing of the possibility of such damage.
              </p>
            </section>

            <section>
              <h2>6. Revisions and Errata</h2>
              <p>
                The materials appearing on Doctors Lab's website could include technical, typographical, 
                or photographic errors. Doctors Lab does not warrant that any of the materials on its 
                website are accurate, complete, or current. Doctors Lab may make changes to the materials 
                contained on its website at any time without notice.
              </p>
            </section>

            <section>
              <h2>7. Links</h2>
              <p>
                Doctors Lab has not reviewed all of the sites linked to its website and is not responsible 
                for the contents of any such linked site. The inclusion of any link does not imply endorsement 
                by Doctors Lab of the site. Use of any such linked website is at the user's own risk.
              </p>
            </section>

            <section>
              <h2>8. Site Terms of Use Modifications</h2>
              <p>
                Doctors Lab may revise these terms of service for its website at any time without notice. 
                By using this website you are agreeing to be bound by the then current version of these 
                terms of service.
              </p>
            </section>

            <section>
              <h2>9. Contact Information</h2>
              <p>
                If you have any questions about these Terms of Service, please contact us at 
                <a href="mailto:info@drslab.com"> info@drslab.com</a>.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;

